<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons class="ion-text-left">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!--     <ion-title>
      {{ payment.name }} payment
    </ion-title>-->
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col
        class="ion-text-center"
        [ngClass]="{'sm-error': sale.balance > 0}"
      >
        <h4 [ngClass]="{'sm-error': (this.sale.balance > 0), 'sm-pale': true}">
          Total due: {{ saleTotalToBeDisplayed | salonMonsterCurrency }}
        </h4>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <h2>{{ payment.name }} payment of:</h2>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <form [formGroup]="paymentForm" (ngSubmit)="charge()">
          <ion-item lines="none">
            <ion-input
              [maskito]="currencyMask"
              [maskitoElement]="maskPredicate"
              formControlName="payment"
              (ionChange)="updatePayment($event)"
              placeholder="Enter amount"
            >
            </ion-input>
          </ion-item>

          <ion-item *ngIf="!paymentField.valid && submitted">
            <p *ngIf="paymentField.hasError('required')" class="sm-error">
              Oops, a payment is required.
            </p>
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-button
    expand="block"
    fill="clear"
    color="danger"
    *ngIf="showRemoveButton"
    (click)="remove()"
    >Remove</ion-button
  >
</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button
          expand="block"
          color="secondary"
          fill="outline"
          (click)="justSave()"
        >
          {{ sale.isSaleReadyForCheckOut() ? 'Save' : 'Save' }}
        </ion-button>
      </ion-col>
      <!--       <ion-col *ngIf="isPaymentTypeChargeable()">
      <button
        ion-button
        block
        color="primary" 
        (tap)="charge()"
      >
        {{ sale.isSaleReadyForCheckOut() ? 'Charge' : 'Charge' }}
      </button>
    </ion-col>
-->
    </ion-row>
  </ion-toolbar>
</ion-footer>
